import { IsNotEmpty, IsOptional, MaxLength, ValidateIf } from 'class-validator';

import { TranslationsEnum } from '@onArte/shared/enums/common';

export class EventUpdateModel {
  @IsNotEmpty({
    message: TranslationsEnum.ValidationErrorIsNotEmpty
  })
  @MaxLength(128, {
    message: TranslationsEnum.ValidationErrorMaxLength,
    context: {
      max: 128
    }
  })
  public name: string;

  @IsNotEmpty({
    message: TranslationsEnum.ValidationErrorIsNotEmpty
  })
  public published: boolean;

  @IsNotEmpty({
    message: TranslationsEnum.ValidationErrorIsNotEmpty
  })
  @ValidateIf((model: EventUpdateModel): boolean => model.published)
  public startTimestamp?: number;

  @IsNotEmpty({
    message: TranslationsEnum.ValidationErrorIsNotEmpty
  })
  @ValidateIf((model: EventUpdateModel): boolean => model.published)
  public endTimestamp?: number;

  @IsNotEmpty({
    message: TranslationsEnum.ValidationErrorIsNotEmpty
  })
  @ValidateIf((model: EventUpdateModel): boolean => model.published)
  public coverPhotoId?: string;

  @IsOptional()
  @MaxLength(500, {
    message: TranslationsEnum.ValidationErrorMaxLength,
    context: {
      max: 500
    }
  })
  public description?: string;

  @IsOptional()
  @MaxLength(500, {
    message: TranslationsEnum.ValidationErrorMaxLength,
    context: {
      max: 500
    }
  })
  public offerCondition?: string;

  constructor(
    name: string,
    published: boolean,
    startTimestamp: number,
    endTimestamp: number,
    coverPhotoId?: string,
    description?: string,
    offerCondition?: string
  ) {
    this.name = name;
    this.published = published;
    this.startTimestamp = startTimestamp;
    this.endTimestamp = endTimestamp;
    this.coverPhotoId = coverPhotoId;
    this.description = description;
    this.offerCondition = offerCondition;
  }
}
